import React from 'react';
import { CircularAvatar } from './CircularAvatar';
import { Hospital } from '@medely/web-components/icons';

export const Facility = () => {
  return (
    <CircularAvatar color="accent.backing-1" width="40px" height="40px">
      <Hospital htmlColor="#3E3E83" width="20px" />
    </CircularAvatar>
  );
};
